import { render, staticRenderFns } from "./AmazonCertification.vue?vue&type=template&id=62384ff5&scoped=true"
import script from "./AmazonCertification.vue?vue&type=script&lang=js"
export * from "./AmazonCertification.vue?vue&type=script&lang=js"
import style0 from "./AmazonCertification.vue?vue&type=style&index=0&id=62384ff5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62384ff5",
  null
  
)

export default component.exports